import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import {
  isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser, getFirstPageForLoggedInUser,
} from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import chartsMaps from './routes/charts-maps'
import formsTable from './routes/forms-tables'
import summaryLotto from './routes/summary-lotto'
import accountMembers from './routes/account-members'
import myAccount from './routes/my-account'
import settingLotto from './routes/setting-lotto'
import api from './routes/api'
import report from './routes/report'
import others from './routes/others'
// eslint-disable-next-line import/extensions
import system from './routes/system'
import invoice from './routes/invoice'
import fraudDetection from './routes/fraud-detection'
import audit from './routes/audit'
import security from './routes/security'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    // { path: '/', redirect: { name: 'dashboard-ecommerce' } },
    { path: '/', redirect: { name: 'dashboard-statistics' } },
    { path: '/dashboard', redirect: { name: 'dashboard-statistics' } },
    ...apps,
    ...dashboard,
    ...pages,
    ...chartsMaps,
    ...formsTable,
    ...uiElements,
    ...myAccount,
    ...summaryLotto,
    ...accountMembers,
    ...invoice,
    ...report,
    ...settingLotto,
    ...api,
    ...others,
    ...system,
    ...fraudDetection,
    ...security,
    ...audit,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

const isBackOfficeRole = role => role === 'admin' || role === 'sub'

const hasManageAll = ability => (ability || []).some(v => v.action === 'manage' && v.subject === 'all')

const isMasterManageAll = userData => userData
  && isBackOfficeRole(userData.role)
  && userData.agent === 'master'
  && hasManageAll(userData.ability)

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })
    // If logged in => not authorized
    if (to.name === 'dashboard-statistics') {
      // const userData = getUserData()
      // next(getFirstPageForLoggedInUser(userData ? userData.ability : null))
      return next(getFirstPageForLoggedInUser())
    }
    return next({ name: 'misc-not-authorized' })
  }
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    return next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }
  if (to.name === 'system-setting') {
    const userData = getUserData()
    if (userData.agent !== 'master') return next({ name: 'misc-not-authorized' })
  }

  if (to.name === 'login-sessions' || to.name === 'security-settings') {
    const userData = getUserData()
    if (!isMasterManageAll(userData)) return next({ name: 'misc-not-authorized' })
  }

  // Fraud Detection Config - Master only
  if (to.name === 'fraud-detection-config') {
    const userData = getUserData()
    if (userData.agent !== 'master') return next({ name: 'misc-not-authorized' })
  }

  // Huay Dashboard - Master only
  if (to.name === 'huay-dashboard') {
    const userData = getUserData()
    if (userData.agent !== 'master') return next({ name: 'misc-not-authorized' })
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
